module.exports = __webpack_public_path__ + "img/newton.d3e879d5.svg";